import { render } from "./ImmutableXIcon.vue?vue&type=template&id=6976ab44"
const script = {}
script.render = render

export default script